import { useContext } from "react";

import { SurveyQuizContext } from "../contexts/surveyQuizContext";

export const useContextSurveyQuiz = () => {
  const surveyQuiz = useContext(SurveyQuizContext);
  return surveyQuiz;
};
